import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=e86956a4&scoped=true&lang=pug&"
import script from "./CheckBox.vue?vue&type=script&lang=coffee&"
export * from "./CheckBox.vue?vue&type=script&lang=coffee&"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=e86956a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86956a4",
  null
  
)

export default component.exports